import Entity from "entity";

export default class Frente extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/V9WGe9b9uVURAmSWqZjR/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO")
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "frente";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 0.8, filter: true },
            { field: "cliente.nome", headerName: "Cliente", flex: 1, filter: true },
            { field: "frente", headerName: "Frente", flex: 1, filter: true },
            { field: "servico", headerName: "Serviço", flex: 1, filter: true },
        ];
    }
}
